import { fetchBookingsFromContacts } from 'flux/clients/bookings';
import { fetchLastMessages } from 'flux/clients/messages2';

import ActionTypes from './ActionTypes';

export interface Actions {
  fetchContacts: (arg: { page: number; pageSize: number }) => void;
}

export default function actionsFactory(
  dispatch: (action: ActionTypes) => void,
): Actions {
  return {
    fetchContacts: ({ page, pageSize }) => {
      dispatch({ type: 'CONTACTS:FETCHING', payload: { page } });

      fetchLastMessages({ page, pageSize })
        .then((result) => {
          dispatch({ type: 'CONTACTS:FETCHING_SUCCESS', payload: { result } });

          fetchBookingsFromContacts({
            contactIds: result.data.map(({ id }) => id),
          }).then((result) =>
            dispatch({
              type: 'CONTACTS:FETCHING_BOOKINGS_SUCCESS',
              payload: { result },
            }),
          );
        })
        .then((error) =>
          dispatch({ type: 'CONTACTS:FETCHING_ERROR', payload: { error } }),
        );
    },
  };
}
